
<po-page-edit
  p-title="Pedido de Compra #{{pedidoCompra.CC7NUM}}"
  [p-breadcrumb]="breadcrumb"
  (p-save)="confirmarPedido()"
  [p-disable-submit]="bloqueiaEdicao"
>
  <form #formPrincipal="ngForm">
    <po-widget>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Fornecedor"
        name="CC7FORNECELOJA"
        [(ngModel)]="fornecedorCodigoLoja"
        p-field-value="CA2CODLOJA"
        p-field-label="CA2NREDUZ"
        [p-columns]="fornecedorColumnsFilters"
        [p-field-format]="fornecedorLookupService.getFieldFormater"
        [p-filter-service]="fornecedorLookupService"
        [p-advanced-filters]="fornecedorLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Fornecedor' }"
        (p-selected)="fornecedorSelecionado($event)"
        p-show-required="true"
        p-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Condição Pagamento"
        name="CC7COND"
        [(ngModel)]="pedidoCompra.CC7COND"
        p-field-value="CE4CODIGO"
        p-field-label="CE4DESCRI"
        [p-columns]="condicaoPagamentoColumnsFilters"
        [p-field-format]="condicaoPagamentoLookupService.getFieldFormater"
        [p-filter-service]="condicaoPagamentoLookupService"
        [p-advanced-filters]="condicaoPagamentoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Condição de Pagamento' }"
        p-show-required="true"
        p-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Usuário Solicitante"
        name="CC7USER"
        [(ngModel)]="pedidoCompra.CC7USER"
        p-field-label="CUSRNOME"
        p-field-value="CUSRID"
        [p-columns]="usuarioColumnsFilters"
        [p-field-format]="usuarioLookupService.getFieldFormater"
        [p-filter-service]="usuarioLookupService"
        [p-advanced-filters]="usuarioLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Usuário' }"
        (p-selected)="usuarioSelecionado($event)"
        p-show-required="true"
        p-required="true"
        p-disabled="true"
      ></po-lookup>
      <po-datepicker class="po-sm-12 po-md-4 po-lg-4"
        name="DC7EMISSAO"
        p-label="Emissão"
        [(ngModel)]="pedidoCompra.DC7EMISSAO"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
        p-disabled="true"
      ></po-datepicker>
      <po-lookup class="po-sm-12 po-md-4 po-lg-4"
        p-label="TES Padrão para o PC"
        name="CC7TESPADRAO"
        [(ngModel)]="tesPadrao"
        p-field-value="CF4CODIGO"
        p-field-label="CF4TEXTO"
        [p-columns]="tesColumnsFilters"
        [p-field-format]="tesLookupService.getFieldFormater"
        [p-filter-service]="tesLookupService"
        [p-advanced-filters]="tesLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'TES' }"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-button class="po-sm-12 po-md-3 po-lg-2 po-mt-4" p-type="default" p-label="Solicitação de Compra" (p-click)="solicitacaoCompraModalOpen()" [p-disabled]="bloqueiaEdicao"></po-button>
    </po-widget>
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="pedidoCompra.items"
      [p-columns]="tabelaItensColunas"
      [p-actions]="tabelaSolicitacaCompraActions"
      [p-sort]="false"
      p-spacing="small"
      p-height="400"
      p-container="true"
    ></po-table>
    <po-button class="po-sm-12 po-md-12 po-lg-12 po-mt-2" p-type="default" p-label="Adicionar Itens" (p-click)="adicionarItem()" [p-disabled]="bloqueiaEdicao"></po-button>
    <po-info class="po-sm-12 po-md-12 po-lg-4 po-mt-2" p-label="Valor Total do Pedido" p-orientation='horizontal' p-value="{{valorTotal | currency:'BRL'}}"></po-info>
  </form>
</po-page-edit>


<po-modal
  #modalItem
  p-size="xl"
  p-title="Editar Item #{{pedidoCompraItem.CC7ITEM}}"
>
  <form #formItem="ngForm">
    <po-widget
      [p-disabled]="bloqueiaEdicao"
    >
      <po-lookup class="po-sm-12 po-md-12 po-lg-12"
        p-label="Produto"
        name="CC7PRODUTO"
        [(ngModel)]="pedidoCompraItem.CC7PRODUTO"
        p-field-value="CB1COD"
        p-field-label="CB1DESC"
        [p-columns]="produtoColumnsFilters"
        [p-field-format]="produtoLookupService.getFieldFormater"
        [p-filter-service]="produtoLookupService"
        [p-advanced-filters]="produtoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Produto' }"
        [p-filter-params]="{CB1MSBLQL: '2'}"
        (p-selected)="produtoSelecionado($event)"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao || pedidoCompraItem.CC7NUMSC !== ''"
      ></po-lookup>

      <po-input class="po-sm-12 po-md-12 po-lg-12"
        name="CC7OBS"
        p-label="Observação"
        [(ngModel)]="pedidoCompraItem.CC7OBS"
        p-required="true"
        p-show-required="true"
        p-maxlength="100"
        [p-disabled]="bloqueiaEdicao"
      ></po-input>
      <po-input class="po-sm-4 po-md-1 po-lg-1"
        name="CC7UM"
        p-label="UM"
        [(ngModel)]="pedidoCompraItem.CC7UM"
        p-disabled="true"
      ></po-input>
      <po-decimal class="po-sm-4 po-md-3 po-lg-3 maisti-input-number"
        name="CC7QUANT"
        p-label="Quantidade"
        [(ngModel)]="pedidoCompraItem.NC7QUANT"
        p-decimals-length="3"
        [p-max]="pedidoCompraItem.NC7QTDSOL>0?pedidoCompraItem.NC7QTDSOL:99999999.999"
        p-min="0.001"
        p-required="true"
        p-show-required="true"
        (p-change)="calcularTotalItem()"
        [p-disabled]="bloqueiaEdicao"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-3 maisti-input-number"
        name="CC7PRECO"
        p-label="Preço Unitário"
        [(ngModel)]="pedidoCompraItem.NC7PRECO"
        p-decimals-length="5"
        p-max="9999999999.99999"
        p-min="0.00001"
        p-required="true"
        p-show-required="true"
        (p-change)="calcularTotalItem()"
        p-icon="po-icon-money"
        [p-disabled]="bloqueiaEdicao"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-3 maisti-input-number"
        name="CC7TOTAL"
        p-label="Total do Item"
        [(ngModel)]="pedidoCompraItem.NC7TOTAL"
        p-decimals-length="2"
        p-max="99999999999.99"
        p-min="0.01"
        p-required="true"
        p-show-required="true"
        p-readonly="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Armazém"
        name="CC7LOCAL"
        [(ngModel)]="pedidoCompraItem.CC7LOCAL"
        p-field-value="CNNRCODIGO"
        p-field-label="CNNRDESCRI"
        [p-columns]="armazemColumnsFilters"
        [p-field-format]="armazemLookupService.getFieldFormater"
        [p-filter-service]="armazemLookupService"
        [p-advanced-filters]="armazemLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Armazém' }"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-4 po-lg-4"
        p-label="TES"
        name="CC7TES"
        [(ngModel)]="pedidoCompraItem.CC7TES"
        p-field-value="CF4CODIGO"
        p-field-label="CF4TEXTO"
        [p-columns]="tesColumnsFilters"
        [p-field-format]="tesLookupService.getFieldFormater"
        [p-filter-service]="tesLookupService"
        [p-advanced-filters]="tesLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'TES' }"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-datepicker class="po-sm-12 po-md-3 po-lg-3"
        name="DC7DATPRF"
        p-label="Necessidade"
        [(ngModel)]="pedidoCompraItem.DC7DATPRF"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
        [p-disabled]="bloqueiaEdicao"
      ></po-datepicker>
      <po-lookup class="po-sm-12 po-md-6 po-lg-5"
        p-label="Conta Contábil"
        name="CC7CONTA"
        [(ngModel)]="pedidoCompraItem.CC7CONTA"
        p-field-value="CCT1CONTA"
        p-field-label="CCT1DESC01"
        [p-columns]="contaContabilColumnsFilters"
        [p-field-format]="contaContabilLookupService.getFieldFormater"
        [p-filter-service]="contaContabilLookupService"
        [p-advanced-filters]="contaContabilLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Conta Contábil' }"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-5"
        p-label="Centro de Custo"
        name="CC7CC"
        [(ngModel)]="pedidoCompraItem.CC7CC"
        p-field-value="CCTTCUSTO"
        p-field-label="CCTTDESC01"
        [p-columns]="centroCustoColumnsFilters"
        [p-field-format]="centroCustoLookupService.getFieldFormater"
        [p-filter-service]="centroCustoLookupService"
        [p-advanced-filters]="centroCustoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Centro de Custo' }"
        p-required="true"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
      ></po-lookup>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Estimativa de Negociação"
        name="CC7ZCDNEGO"
        [(ngModel)]="pedidoCompraItem.CC7ZCDNEGO"
        p-field-value="CZACCDNGC"
        p-field-label="CZACDSCFAZ"
        [p-columns]="estimativaNegociacaoColumnsFilters"
        [p-field-format]="estimativaNegociacaoLookupService.getFieldFormater"
        [p-filter-service]="estimativaNegociacaoLookupService"
        [p-advanced-filters]="estimativaNegociacaoLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Estimativa de Negociação' }"
        p-required="false"
        p-show-required="true"
        [p-disabled]="bloqueiaEdicao"
        [p-disabled]="true"
      ></po-lookup>
      <po-button class="po-sm-12 po-md-4 po-lg-3 po-mt-4"
        p-label="Estimativa Negociação"
        p-icon="po-icon-search"
        (p-click)="estimativaNegociacaoListaModalOpen()"
      ></po-button>
      <po-divider class="po-sm-12 po-md-12 po-lg-12" p-label="Dados da Solicitação de Compra"></po-divider>
      <po-input class="po-sm-6 po-md-3 po-lg-2"
        name="CC7NUMSC"
        p-label="Solicitação"
        [(ngModel)]="pedidoCompraItem.CC7NUMSC"
        p-required="false"
        p-show-required="true"
        p-maxlength="6"
        p-disabled="true"
      ></po-input>
      <po-input class="po-sm-6 po-md-3 po-lg-2"
        name="CC7ITEMSC"
        p-label="Item Solicitação"
        [(ngModel)]="pedidoCompraItem.CC7ITEMSC"
        p-required="false"
        p-show-required="true"
        p-maxlength="3"
        p-disabled="true"
      ></po-input>
      <po-decimal class="po-sm-4 po-md-3 po-lg-3 maisti-input-number"
        name="NC7QTDSOL"
        p-label="Qtd Saldo Solicitação"
        [(ngModel)]="pedidoCompraItem.NC7QTDSOL"
        p-decimals-length="3"
        p-max="99999999.999"
        p-min="0.000"
        p-required="false"
        p-show-required="true"
        p-disabled="true"
      ></po-decimal>

    </po-widget>
  </form>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Gravar Item"
      p-icon="po-icon-ok"
      (p-click)="confirmarItem()"
      [p-disabled]="bloqueiaEdicao"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalItem.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>


<po-modal
  #modalSolicitacaoCompra
  p-size="lg"
  p-title="Solicitação de Compra"
>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-striped]="true"
    [p-items]="tabelaSolicitacaoCompraItens"
    [p-columns]="tabelaSolicitacaCompraColunas"
    [p-sort]="true"
    p-spacing="small"
    p-height="400"
    p-container="true"
    p-selectable="true"
    p-hide-table-search="false"
    [p-filter-type]="poSearchFilterMode"
    (p-selected)="selectLinha($event)"
     (p-unselected)="selectLinha($event)"
  ></po-table>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Confirmar Itens Selecionados"
      p-icon="po-icon-ok"
      (p-click)="confirmarSolicitacaoCompra()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalSolicitacaoCompra.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>

<po-modal
  #modalEstimativaNegociacaoLista
  p-size="lg"
  p-title="Estimativa de Negociação"
>
  <po-input class="po-sm-12 po-md-4 po-lg-3"
    name="CZACCDNGC"
    p-label="Código"
    [(ngModel)]="tabelaEstimativaNegociacaoFiltro.dados.CZACCDNGC"
  ></po-input>
  <po-lookup class="po-sm-12 po-md-4 po-lg-3"
    p-label="Fazenda"
    name="CZACFAZEND_filtro"
    [(ngModel)]="tabelaEstimativaNegociacaoFiltro.dados.CZACFAZENDA"
    p-field-value="CZABCODIGO"
    p-field-label="CZABDESC"
    [p-columns]="fazendaColumnsFilters"
    [p-field-format]="fazendaLookupService.getFieldFormater"
    [p-filter-service]="fazendaLookupService"
    [p-advanced-filters]="fazendaLookupService.getAdvancedFilter()"
    [p-literals]="{ modalTitle: 'Fazenda' }"
    (p-selected)="fazendaSelecionada($event)"
    p-show-required="true"
    p-required="true"
  ></po-lookup>
  <po-input class="po-sm-12 po-md-4 po-lg-3"
    name="CZACDSCFAZ"
    p-label="Nome Fazenda"
    [(ngModel)]="tabelaEstimativaNegociacaoFiltro.dados.CZACDSCFAZ"
  ></po-input>
  <po-button class="po-sm-12 po-md-4 po-lg-3 po-mt-4"
    p-label="Filtrar"
    p-icon="po-icon-search"
    (p-click)="tabelaEstimativaNegociacaoLoad()"
  ></po-button>
  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-striped]="true"
    [p-items]="tabelaEstimativaNegociacaoItens"
    [p-columns]="tabelaEstimativaNegociacaoColunas"
    [p-sort]="true"
    p-spacing="small"
    p-height="400"
    p-container="true"
    p-hide-table-search="true"
    p-hide-columns-manager="true"
    [p-filter-type]="poSearchFilterMode"
    [p-actions]="tabelaEstimativaNegociacaoActions"
    p-actions-right="true"
    p-selectable="true"
    (p-selected)="estimativaNegociacaoSelecionada($event)"
    p-single-select="true"
  ></po-table>
  <po-button class="po-sm-12 po-md-4 po-lg-3 po-mt-4"
    p-label="Adicionar Estimativa Negociação"
    p-icon="po-icon-new"
    (p-click)="estimativaNegociacaoIncluir()"
  ></po-button>
</po-modal>


<po-modal
  #modalEstimativaNegociacao
  p-size="lg"
  p-title="Estimativa de Negociação"
>
  <form #formEstimativaNegociacao="ngForm">
    <po-widget>
      <po-lookup class="po-sm-12 po-md-6 po-lg-4"
        p-label="Fazenda"
        name="CZACFAZEND"
        [(ngModel)]="estimativaNegociacao.CZACFAZEND"
        p-field-value="CZABCODIGO"
        p-field-label="CZABDESC"
        [p-columns]="fazendaColumnsFilters"
        [p-field-format]="fazendaLookupService.getFieldFormater"
        [p-filter-service]="fazendaLookupService"
        [p-advanced-filters]="fazendaLookupService.getAdvancedFilter()"
        [p-literals]="{ modalTitle: 'Fazenda' }"
        (p-selected)="fazendaSelecionada($event)"
        p-show-required="true"
        p-required="true"
      ></po-lookup>
      <po-combo class="po-sm-12 po-md-4 po-lg-3"
        name="CZACCLTORA"
        p-label="Classe Geral da Tora"
        [(ngModel)]="estimativaNegociacao.CZACCLTORA"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/sx3/x3combo/ZAC_CLTORA"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-required="false"
        p-show-required="true"
        p-clean="true"
        p-change-on-enter="true"
      ></po-combo>
      <po-combo class="po-sm-12 po-md-4 po-lg-3"
        name="CZACCOMPRI"
        p-label="Comprimento da Tora"
        [(ngModel)]="estimativaNegociacao.CZACCOMPRI"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/sx3/x3combo/ZAC_COMPRI"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-required="false"
        p-show-required="true"
        p-clean="true"
        p-change-on-enter="true"
      ></po-combo>
      <po-combo class="po-sm-12 po-md-4 po-lg-3"
        name="CZACDIAOPR"
        p-label="Operador"
        [(ngModel)]="estimativaNegociacao.CZACDIAOPR"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/sx3/x3combo/ZAC_DIAOPR"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-required="false"
        p-clean="true"
        p-change-on-enter="true"
        p-show-required="true"
      ></po-combo>
      <po-input class="po-sm-6 po-md-3 po-lg-2"
        name="CZACCLDDE"
        p-label="Classe Diamétrica De"
        [(ngModel)]="estimativaNegociacao.CZACCLDDE"
        p-required="false"
        p-show-required="true"
        p-maxlength="3"
        p-disabled="false"
      ></po-input>
      <po-input class="po-sm-6 po-md-3 po-lg-2"
        name="CZACCLDATE"
        p-label="Classe Diamétrica Até"
        [(ngModel)]="estimativaNegociacao.CZACCLDATE"
        p-required="false"
        p-show-required="true"
        p-maxlength="5"
        p-disabled="false"
      ></po-input>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACPRCPE"
        p-label="Preço em Pé"
        [(ngModel)]="estimativaNegociacao.NZACPRCPE"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACCUSCLT"
        p-label="Custo de Colheita"
        [(ngModel)]="estimativaNegociacao.NZACCUSCLT"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACVLRFRT"
        p-label="Valor do Frete"
        [(ngModel)]="estimativaNegociacao.NZACVLRFRT"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACPRCPLA"
        p-label="Preço Posto Planta"
        [(ngModel)]="estimativaNegociacao.NZACPRCPLA"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACPISCOF"
        p-label="PIS/COFINS"
        [(ngModel)]="estimativaNegociacao.NZACPISCOF"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACICMS"
        p-label="ICMS"
        [(ngModel)]="estimativaNegociacao.NZACICMS"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-datepicker class="po-sm-12 po-md-3 po-lg-2"
        name="DZACDTINI"
        p-label="Data Inicial da Vigência"
        [(ngModel)]="estimativaNegociacao.DZACDTINI"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
      ></po-datepicker>
      <po-datepicker class="po-sm-12 po-md-3 po-lg-2"
        name="DZACDTFIM"
        p-label="Data final da Vigência"
        [(ngModel)]="estimativaNegociacao.DZACDTFIM"
        [p-iso-format]="formatExtended"
        p-format="dd/mm/yyyy"
      ></po-datepicker>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACPRCFOB"
        p-label="Preço FOB"
        [(ngModel)]="estimativaNegociacao.NZACPRCFOB"
        p-decimals-length="4"
        p-max="99999.9999"
        p-min="0.0000"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-input class="po-sm-6 po-md-3 po-lg-2"
        name="CZACPROJET"
        p-label="Projetos"
        [(ngModel)]="estimativaNegociacao.CZACPROJET"
        p-required="false"
        p-show-required="true"
        p-maxlength="25"
        p-disabled="false"
      ></po-input>
      <po-combo class="po-sm-12 po-md-4 po-lg-3"
        name="CZACINTERV"
        p-label="Intervenção"
        [(ngModel)]="estimativaNegociacao.CZACINTERV"
        p-icon="po-icon-search"
        p-field-label="label"
        p-field-value="value"
        p-filter-service="{{urlApiProtheus}}/wsrbase/sx3/x3combo/ZAC_INTERV"
        [p-filter-params]="{combobox:'S'}"
        p-disabled-init-filter="false"
        p-required="false"
        p-show-required="true"
        p-clean="true"
        p-change-on-enter="true"
      ></po-combo>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACMANEST"
        p-label="Manutenção Estrada"
        [(ngModel)]="estimativaNegociacao.NZACMANEST"
        p-decimals-length="2"
        p-max="99999999.99"
        p-min="0.00"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
      <po-decimal class="po-sm-4 po-md-3 po-lg-2 maisti-input-number"
        name="NZACOPERAD"
        p-label="Operadora"
        [(ngModel)]="estimativaNegociacao.NZACOPERAD"
        p-decimals-length="2"
        p-max="99999999.99"
        p-min="0.00"
        p-required="false"
        p-show-required="true"
        p-icon="po-icon-money"
      ></po-decimal>
    </po-widget>
  </form>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-10"
      p-label="Gravar Estimativa de Negociação"
      p-icon="po-icon-ok"
      (p-click)="confirmarEstimativaNegociacao()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-2"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalEstimativaNegociacao.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>

<po-modal
  #modalProduto
  p-size="lg"
  p-title="Produto"
>
  <form #formPrincipal="ngForm">
    <po-combo class="po-sm-12 po-md-3"
      name="CGRPNVL1"
      p-label="Grupo Nvl 1"
      [(ngModel)]="filtroProdutoLista.CGRPNVL1"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc0"
      [p-filter-params]="{combobox:'S'}"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      (p-change)="onChangeNvl1()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CGRPNVL2"
      p-label="Grupo Nvl 2"
      [(ngModel)]="filtroProdutoLista.CGRPNVL2"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc1"
      [p-filter-params]="filterZC1"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      [p-disabled]="filtroProdutoLista.CGRPNVL1 == ''"
      (p-change)="onChangeNvl2()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CB1XPDM"
      p-label="PDM"
      [(ngModel)]="filtroProdutoLista.CB1XPDM"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc2"
      [p-filter-params]="filterZC2"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      (p-change)="onChangePDM()"
      p-change-on-enter="true"
    ></po-combo>

    <po-combo class="po-sm-12 po-md-3"
      name="CB1POSIPI"
      p-label="NCM"
      [(ngModel)]="filtroProdutoLista.CB1POSIPI"
      p-icon="po-icon-search"
      p-field-label="label"
      p-field-value="value"
      p-filter-service="{{urlApiProtheus}}/wsrpdm/zc6"
      [p-filter-params]="filterPDMCombo"
      p-disabled-init-filter="false"
      p-infinite-scroll="true"
      p-required="true"
      p-clean="true"
    ></po-combo>
    <po-button class="po-md-12"
      p-label="Filtrar"
      p-icon="po-icon-search"
      (p-click)="buscarProduto(true)"
    ></po-button>
  </form>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-striped]="true"
    [p-items]="produtoItems"
    [p-columns]="produtoColunas"
    [p-sort]="true"
    p-spacing="small"
    p-height="310"
    p-container="true"
    p-selectable="true"
    p-single-select="true"
    p-hide-table-search="false"
    [p-show-more-disabled]="produtosShowMoreDisable"
    (p-show-more)="buscarProduto(false)"
    [p-filter-type]="poSearchFilterMode"
  ></po-table>
  <po-modal-footer>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Confirmar seleção"
      p-icon="po-icon-ok"
      (p-click)="confirmarSelecaoProduto()"
    ></po-button>
    <po-button class="po-sm-12 po-md-6 po-lg-6"
      p-label="Cancelar"
      p-icon="po-icon-cancel"
      (p-click)="modalProduto.close()"
      p-danger="true"
    ></po-button>
  </po-modal-footer>
</po-modal>
